<template>
  <el-aside :width="asideWidth">
    <div class="nav-main-box">
      <div class="nav-main-logo">
        <a class="shared-team-logo-wrap">
          <img src="../../assets/yxpt.jpg" alt="logo" width="56px" />
        </a>
      </div>
      <el-menu
        class="main-nav"
        :default-active="mainNavActive"
        @select="handleSelect"
      >
        <el-menu-item
          :key="key"
          v-for="(item, key) in mainNavData"
          :index="item.menu_id"
        >
          <i :class="item.icon"></i>
          <span slot="title">{{ item.menu_name }}</span>
        </el-menu-item>
      </el-menu>
      <div id="shared-corner">
        <el-dropdown
          :hide-timeout="500"
          :show-timeout="100"
          id="self-user"
          :hide-on-click="false"
        >
          <i class="el-icon-s-custom bottom-icon search-icon"></i>
          <el-dropdown-menu slot="dropdown">
            <div @click="topage('/user')">
              <el-dropdown-item icon="el-icon-user">个人中心</el-dropdown-item>
            </div>
            <div @click="topage('/upDataPassword')">
              <el-dropdown-item icon="el-icon-lock">更新密码</el-dropdown-item>
            </div>
            <!-- <div @click="topage('/project')">
              <el-dropdown-item icon="el-icon-lock">项目表单管理</el-dropdown-item>
            </div> -->
            <div @click="handleClick">
              <el-dropdown-item icon="el-icon-switch-button" divided
                >退出登录</el-dropdown-item
              >
            </div>
          </el-dropdown-menu>
        </el-dropdown>
        <div id="notice-center">
          <i class="el-icon-s-comment bottom-icon search-icon"></i>
        </div>
      </div>
    </div>
    <div v-if="isNavSubShow" class="nav-sub-box">
      <h2 class="sub-nav-title">{{ mainNavSelf.remark || "" }}</h2>
      <el-menu
        :default-active="subNavSelf"
        class="sub-nav-list"
        @select="subNavSelfItem"
        @open="handleOpen"
        @close="handleClose"
      >
        <template v-for="item in subNavData">
          <el-submenu :index="item.url" v-if="item.children" :key="item.id">
            <template slot="title">{{ item.menu_name }}</template>
            <el-menu-item
              v-for="items in item.children"
              :key="items.id"
              :index="items.url"
              >{{ items.menu_name }}</el-menu-item
            >
          </el-submenu>
          <el-menu-item :index="item.url" :key="item.id" v-else>
            <div
              :class="subNavSelfItemPath == item.url ? 'qwe' : ''"
              style="text-align: center;"
              slot="title"
            >
              {{ item.menu_name }}
            </div>
          </el-menu-item>
        </template>
      </el-menu>
    </div>
  </el-aside>
</template>

<script>
import * as user from "@/api/user";
import {
  _setSessionStore,
  _getSessionStore,
  _removeSessionStore
} from "@/utils/storage";
export default {
  name: "aside.vue",
  // created: {
  //   let path = this.$route.path;
  // },
  props: {
    mainNavData: {
      type: [Object, Array],
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      subNavSelfItemPath: "",
      // 路由
      subNavData: [],
      isNavSubShow: false,
      asideWidth: "92px",
      mainNavSelf: {
        subtitle: "home"
      },
      mainNavActive: "/dashboard",
      subNavSelf: ""
    };
  },
  created() {},
  mounted() {
    //钩子函数
    let path = this.$route.path;
    let navSelf = _getSessionStore("navSelf", "JSONStr");
    if (navSelf && typeof navSelf != "undefined" && navSelf != 0) {
      this.isNavSubShow = navSelf.isNavSubShow;
      this.subNavData = navSelf.subNavData;
      this.asideWidth = navSelf.asideWidth;
      this.mainNavSelf = navSelf.mainNavSelf;
      this.mainNavActive = navSelf.mainNavActive;
      this.subNavSelf = path;
    } else {
      this.setNavSelf(path, "");
    }
  },
  methods: {
    subNavSelfItem(index, indexPath) {
      if (index == this.subNavSelfItemPath) return;
      this.subNavSelfItemPath = index;
      this.$router.push(index);
    },
    handleClick() {
      this.$confirm("是否退出登录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          user.loginOut().then(res => {
            this.$message({
              type: "success",
              message: "退出成功!"
            });
            sessionStorage.clear();
            window.location.href = process.env.BASE_URL || "/";
          });
          // this.$router.push('/login');
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消退出"
          });
        });
    },
    topage(e) {
      this.$router.push(e);
      this.isNavSubShow = false;
      this.asideWidth = "92px";
      this.subNavData = "";
    },
    handleSelect(key, keyPath) {
      // if(key == this.$route.path) return;
      this.$emit("chengeMenuItem", key);
      let navSelf = _getSessionStore("navSelf", "JSONStr");
      let that = this;
      if (navSelf && typeof navSelf != "undefined" && navSelf != 0) {
        if (key === navSelf.mainNavActive) {
          return;
        }
      }
      // if (key = this.$route.path) return;
      if (key === "/" || key === "/dashboard") {
        this.setNavSelf(key, "");
        // if(key == this.$route.path) return;
        if (key != this.$route.path) {
          that.$router.push("/");
        }
        return;
      }
      let nav = that.mainNavData;
      let childrenRoute = "";
      for (const item of nav) {
        if (item.menu_id === key) {
          //设置当前主导航数据
          that.mainNavSelf = item;
          //判断当前主菜单是否有子集

          if (item.children) {
            that.isNavSubShow = true;
            that.asideWidth = "224px";
            that.subNavData = item.children;
            let childrenId;
            if (item.children[0].children) {
              childrenRoute = item.children[0].children[0].url;
              childrenId = item.children[0].children[0].id;
            } else {
              childrenRoute = item.children[0].url;
              childrenId = item.children[0].id;
            }
            if (childrenRoute == this.subNavSelfItemPath) return;
            this.subNavSelfItemPath = childrenRoute;
            that.$router.push(childrenRoute);
          } else {
            if (item.url == this.subNavSelfItemPath) return;
            that.isNavSubShow = false;
            that.asideWidth = "92px";
            that.subNavData = "";
            that.$router.push(item.url);
          }
          // 设置当前路由

          that.setNavSelf(item.url, childrenRoute);
          break;
        }
      }
    },
    setNavSelf(path, subNav) {
      //设置当前菜单
      let that = this;
      //缓存当前
      if (subNav === "") {
        that.mainNavSelf = that.mainNavData[0];
        that.isNavSubShow = false;
        that.asideWidth = "92px";
      }
      _setSessionStore(
        "navSelf",
        {
          isNavSubShow: that.isNavSubShow,
          asideWidth: that.asideWidth,
          mainNavSelf: that.mainNavSelf,
          mainNavActive: path,
          subNavSelf: subNav,
          subNavData: that.subNavData
        },
        "JSONStr"
      );
    },

    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {}
  }
};
</script>

<style lang="scss">
.qwe {
  color: #323233;
  background-color: #f1f1f1;
}
#shared-corner,
#self-user {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  color: #ffffff;
}

#shared-corner {
  -webkit-box-flex: 0;
  -webkit-flex: 0 0 42px;
  -moz-box-flex: 0;
  flex: 0 0 42px;
  background-color: #535353;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -moz-box-orient: horizontal;
  -moz-box-direction: normal;
  flex-direction: row;

  #self-user,
  #notice-center {
    display: flex;
    font-size: 18px;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    align-items: center;
    position: relative;
    -webkit-box-flex: 1;
    -webkit-flex: 1 1 50%;
    -moz-box-flex: 1;
    flex: 1 1 50%;
    cursor: pointer;

    .bottom-icon {
      display: block;
      background-size: cover;
    }
  }
}

#self-user:after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto 0;
  width: 1px;
  height: 16px;
  background-color: #fff;
  opacity: 0.2;
  -webkit-transform: scaleX(0.5);
  -moz-transform: scaleX(0.5);
  transform: scaleX(0.5);
}

/*#notice-center {*/
/*  -webkit-box-sizing: border-box;*/
/*  -moz-box-sizing: border-box;*/
/*  box-sizing: border-box;*/
/*}*/
.notice-center-m_dot_1oaKE {
  position: absolute;
  right: 5px;
  top: 5px;
  background: #f44;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  display: inline-block;
  font-size: 0;
  height: 8px;
  width: 8px;
}

.el-aside {
  .nav-main-box {
    position: fixed;
    width: 92px;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    background-color: #393d49;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -moz-box-orient: vertical;
    -moz-box-direction: normal;
    flex-direction: column;
    overflow: hidden;
    z-index: 2;

    .nav-main-logo {
      position: fixed;
      top: 0;
      bottom: 0;
      height: 56px;
      width: 92px;
      word-break: break-word;
      background: #393d49;
      z-index: 1002;

      .shared-team-logo-wrap {
        display: block;
        margin: 0 16px;
        height: 56px;
        overflow: hidden;
      }
    }

    .main-nav {
      margin-top: 56px;
      padding-right: 20px;
      -webkit-box-sizing: content-box;
      -moz-box-sizing: content-box;
      box-sizing: content-box;
      width: 100%;
      -webkit-box-flex: 1;
      -webkit-flex: 1 1 100%;
      -moz-box-flex: 1;
      flex: 1 1 100%;
      overflow-x: hidden;
      overflow-y: scroll;

      li {
        width: 92px;
        font-size: 14px;
        height: 40px;
        line-height: 40px;
        cursor: pointer;
      }
    }

    .el-menu {
      border: 0px;
      background-color: #393d49;

      .el-menu-item [class^="el-icon-"] {
        width: 18px;
        height: 18px;
        font-size: 18px;
        margin-right: 4px;
      }

      .el-menu-item.is-active {
        color: #333;
        background-color: #fff;
      }

      .el-menu-item {
        color: #ffffff;
        padding: 0px 0px 0px 10px;
        font-size: 14px;
        /*:focus,*/
        /*:hover {*/
        /*  outline: 0;*/
        /*  color: #333;*/
        /*  background-color: #ecf5ff;*/
        /*}*/
      }
    }
  }

  .nav-sub-box {
    position: fixed;
    width: 132px;
    height: 100%;
    margin-left: 92px;
    padding-bottom: 40px;
    background-color: #fff;
    overflow: hidden;
    border-right: 1px solid #ebedf0;
    z-index: 1;

    .sub-nav-title {
      -webkit-box-flex: 0;
      -webkit-flex: 0 0 56px;
      -moz-box-flex: 0;
      flex: 0 0 56px;
      text-align: center;
      width: 100%;
      height: 56px;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      border-bottom: 1px solid #ebedf0;
      font-size: 14px;
      color: #323233;
      line-height: 56px;
      font-weight: 500;
    }

    .sub-nav-list {
      -webkit-box-sizing: content-box;
      -moz-box-sizing: content-box;
      box-sizing: content-box;
      margin-top: 10px;
      overflow-x: hidden;
      overflow-y: scroll;
    }
    .el-menu-item.is-active {
      color: #f0f;
    }
    .el-menu {
      border: 0px;

      li {
        position: relative;
        color: #323233;
        cursor: pointer;
        font-size: 14px;
        // -webkit-box-sizing: border-box;
        // -moz-box-sizing: border-box;
        // box-sizing: border-box;
        background: #fff;
        // text-align: left;

        div {
          width: 132px;
          height: 100%;
          width: 108px;
          min-width: 108px;
          margin-left: -8px;
          color: #323233;
          text-align: center;
          font-size: 14px;
        }
      }

      :hover {
        color: #2d8cf0;
      }

      .el-submenu {
        :hover {
          background-color: #ffffff;
        }
      }

      .el-menu-item {
        height: 36px;
        line-height: 36px;
        text-align: center;
        margin-bottom: 5px;
        width: 108px;
        min-width: 108px;
      }

      .el-submenu__title {
        padding-left: 12px !important;
        height: 40px;
        line-height: 40px;
      }

      // .is-active {
      // 	color: #323233;
      // 	// background-color: #f1f1f1;
      // 	background-color: #00f;
      // 	border-radius: 2px;
      // 	// :hover {
      // 	// 	color: #2d8cf0;
      // 	// }
      // }

      .is-opened {
        color: #323233;
        background-color: #ffffff;
      }
    }
  }
}
</style>
